import {
  GET_DAMAGE_RECEIPT_SUMMARY_REQUEST,
  GET_DAMAGE_RECEIPT_SUMMARY_SUCCESS,
  GET_DAMAGE_RECEIPT_SUMMARY_ERROR
} from "../actions/types";

export const damageReceipt = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DAMAGE_RECEIPT_SUMMARY_REQUEST:
      return {
        loading: true,
      };
    case GET_DAMAGE_RECEIPT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: payload,
      };
    case GET_DAMAGE_RECEIPT_SUMMARY_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
